 <div class="container-fluid banner">
  <img src="assets/services.jpg" >
  <div class="top-left">
    <h1 class="h1">Services</h1>
  </div>
</div><br>

<div class="container">
  <div class="row map-space">
    <ng-container *ngFor="let info of demo_address">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 service-map" [ngClass]="(getId == info?.id)?'active_ptag':none" (click)="getId =info?.id" >
        <p ><b>Address:</b><br><br><span class="branch">{{info?.serviceStorename}}</span><br>{{info?.addressDetails}}</p>
        <a target="_blank" href="{{info?.mapUrl}}"><img src="../../assets/map.png" width="136px" height="144px"><br><span class="map-link">GPS<i class="bi bi-hand-index"></i></span></a>
        <p class="map-contact"><b>Contact :</b>{{info?.contactNo}}<br><b *ngIf="info?.emailid !=''">Email ID :</b>{{info?.email}}</p>
       </div>
    </ng-container>
      <!-- <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 service-map">
        <p><b>Address:</b><br><br><span class="branch">Branch B</span><br>3rd floor Millenium Square Building, Above Ratnadeep Supermarket, Lumbini Avenue, Gachibowli, Hyderabad, 
          Telangana, India 500032<br><br><b>Contact :</b> +91 99676 44556</p>
        <a target="_blank" href="https://g.page/sarathcitycapitalmall?share"><img src="../../assets/map.png" width="136px" height="144px"><br><span class="map-link">GPS<i class="bi bi-hand-index"></i></span></a>
      </div> -->
  </div>
</div>


<div class="container">
  <div class="row">
    <div class="col-lg-12 col-md-12">

      <div class="tabbable-panel">
        <div class="tabbable-line">
          <ul class="nav nav-tabs ">
            <li  class="active">
              <a href="#tab_default_3" data-toggle="tab"> Therapy</a>
            </li>
            <li>
              <a href="#tab_default_4" data-toggle="tab">Care Service</a>
              </li>
              <li>
                <a href="#tab_default_2" data-toggle="tab">Lifestyle Management</a>
              </li>
            <li >
              <a href="#tab_default_1" data-toggle="tab"> Disease Management</a>
            </li>
           
           
           
          </ul>
          <div class="tab-content">
            <div class="tab-pane " id="tab_default_1">
              <div class="container">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dm-1.png" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">DISEASE MANAGEMENT</h5>
                        <h4>Dermatology</h4>
                        <p class="card-text">When any of the Doshas accumulate in the body beyond the desirable limit,
                          the body loses its balance and causes skin diseases.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Treatments that aim to detoxify and cleanse your skin</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Healthy, Blemish free and glowing skin</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Prevent and cure the disease</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Maintains Dosha balance</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Maintains pH level</p>
                        <a  *ngIf="!getToken" class="btn btn-primary" (click)="modalOpen()">BookAppointment</a>
                        <a *ngIf="getToken" [routerLink]="['/request-on-appointment']"
                          [queryParams]="{subCat: 'Dermatology',cat:'DISEASE MANAGEMENT'}" class="btn btn-primary">Book
                          Appointment</a>


                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dm-2.png" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">DISEASE MANAGEMENT</h5>
                        <h4>Thyroid</h4>
                        <p class="card-text">We have a well-balanced integrative therapeutic approach to improve thyroid
                          gland functions.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves body’s Metabolism</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Corrects weight issues</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Corrects Impaired digestion and other Gut issues</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Maintenance of equilibrium in Thyroid gland function</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Mood swings and Irritability management</p>
                        <a  *ngIf="!getToken" class="btn btn-primary" (click)="modalOpen()">BookAppointment</a>
                        <a *ngIf="getToken" [routerLink]="['/request-on-appointment']" [queryParams]="{subCat: 'Thyroid',cat:'DISEASE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>

                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dm-3.png" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">DISEASE MANAGEMENT</h5>
                        <h4>Women Care</h4>
                        <p class="card-text">A service specially designed for the expecting mothers.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Pre-natal care</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Post-natal care</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Brings positive health status of women post delivery</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Regaining mental, emotional and spiritual wellness in women post-delivery to meet demands of
                          family life.</p>
                          <a  *ngIf="!getToken" class="btn btn-primary" (click)="modalOpen()">BookAppointment</a>
                        <a *ngIf="getToken" [routerLink]="['/request-on-appointment']"
                          [queryParams]="{subCat: 'Women Care',cat:'DISEASE MANAGEMENT'}" class="btn btn-primary">Book
                          Appointment</a>
                      </div>
                    </div>
                  </div>
                </div><br>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dm-4.png" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">DISEASE MANAGEMENT</h5>
                        <h4>Trichology</h4>
                        <p class="card-text">A therapy aiming to resolve the hair problems.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Restores hair and scalp health</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Clears dandruff</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves pre-mature greying</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves hair fall and restores moisture</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves immunity of the scalp and provides maximum rejuvenation.</p>
                        <a  *ngIf="!getToken" class="btn btn-primary" (click)="modalOpen()">BookAppointment</a>
                        <a *ngIf="getToken" [routerLink]="['/request-on-appointment']"
                          [queryParams]="{subCat: 'Trichology',cat:'DISEASE MANAGEMENT'}" class="btn btn-primary">Book
                          Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dm-5.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">DISEASE MANAGEMENT</h5>
                        <h4>Gastroenterology</h4>
                        <p class="card-text">Inappropriate eating habits accompanied with certain poor lifestyle choices
                          are responsible for creating digestive disorders.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves digestion</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves whole body health</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves metabolism</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Brings strength to the body</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Natural healing process</p>
                        <a  *ngIf="!getToken" class="btn btn-primary" (click)="modalOpen()">BookAppointment</a>
                        <a *ngIf="getToken" [routerLink]="['/request-on-appointment']"
                          [queryParams]="{subCat: 'Gastroenterology',cat:'DISEASE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tab-pane" id="tab_default_2">
              <div class="container">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/stress2.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">LIFESTYLE MANAGEMENT</h5>
                        <h4>Stress Management</h4>
                        <p class="card-text">A service helping you achieve mental calmness, relaxation and regain peace.
                        </p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Deep feeling of relaxation and Tranquility</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relief from symptoms of Psychosomatic diseases</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reduction in panic attacks</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves memory and Concentration</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Total mind and Body Rejuvenation</p>
                        <a [routerLink]="['/book-service']"
                          [queryParams]="{id:getId,subCat: 'Stress Management',cat:'LIFESTYLE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/weight-management.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">LIFESTYLE MANAGEMENT</h5>
                        <h4>Weight Management</h4>
                        <p class="card-text">A customized weight management service for a healthier life.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Weight Loss</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Inch loss</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves digestion and Metabolism</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reduces Bad Cholesterol</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves overall health</p>
                        <a [routerLink]="['/book-service']"
                          [queryParams]="{id:getId,subCat: 'Weight Management',cat:'LIFESTYLE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dm-3.png" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">LIFESTYLE MANAGEMENT</h5>
                        <h4>Beauty Rejuvenation</h4>
                        <p class="card-text">A treatment, which aims to restore a youthful appearance.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Healthy glowing skin</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Even Skin tone</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Nourishes hair & skin</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Helps in hair growth</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reduces acne and blemishes</p>
                        <a [routerLink]="['/book-service']"
                          [queryParams]="{id:getId,subCat: 'Beauty Rejuvenation',cat:'LIFESTYLE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                </div><br>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/bliss-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">LIFESTYLE MANAGEMENT</h5>
                        <h4>Bliss Therapy</h4>
                        <p class="card-text">A combination of Abhyanga, Shirodhara and Swedana.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Whole body relaxation</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relieves stress and anxiety</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Nourishes scalp and hair</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves health</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Detoxifies the whole body</p>
                        <a [routerLink]="['/book-service']"
                          [queryParams]="{id:getId,subCat: 'Bliss Therapy',cat:'LIFESTYLE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/pain-management-ayurway2.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">LIFESTYLE MANAGEMENT</h5>
                        <h4>Pain Management</h4>
                        <p class="card-text">{{brandData?.brandName}} Pain Management therapies follow a holistic approach.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Pain release</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves strength</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves immunity</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Natural healing process</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Prevent and cure the disease</p>
                        <a [routerLink]="['/book-service']"
                          [queryParams]="{id:getId,subCat: 'Pain Management',cat:'LIFESTYLE MANAGEMENT'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="tab-pane active" id="tab_default_3">
              <div class="container">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/abhyanga-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Abhyanga</h4>
                        <p class="card-text">Abhyanga is a form of external ayurvedic therapy that involves massage of
                          the body with dosha-specific warm herb infused oils.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Promotes optimum Health and Physical fitness</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves body complexion</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Helps maintain skin elasticity</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Helps overcome anxiety and stress</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Induces sound sleep</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Abhyanga',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/shirodhara-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Shirodhara</h4>
                        <p class="card-text">Shirodhara is a form of Ayurveda therapy that involves gently pouring of
                          warm herbal oil to the center of the forehead in a continuous stream.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Shirodhara deeply soothes the nervous system</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Brings about a deep state of relaxation in body and mind by relieving stress</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Increases mental focus and concentration</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Nourishes hair, scalp and strengthens hair follicles thus preventing hair loss and premature
                          greying</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Shirodhara',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/kati-basti-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Kati Basti</h4>
                        <p class="card-text">Kati Basti is a musculoskeletal treatment for disorders of back that
                          involve muscle (mamsa), ligaments, bones (ashti), vertebrae and nerves (majja).</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Restores the alignment of the spine</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Pain free deep tissue therapy</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Helps to reduce toxins accumulating in the muscle tissue</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>An anti-inflammatory, antispasmoic and anti-pain</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Kati Basti',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                </div><br>


                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/dhanyamla-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Dhanyaamla Dhara</h4>
                        <p class="card-text">A treatment procedure in which medicated fermented liquid is poured over
                          the body in monitored streams for a fixed duration of time.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves blood circulation</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Revitalizes the patient's body</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves immunity</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relieves body ache and muscle spasms</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves skin complexion</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Dhanyaamla Dhara',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/nasyam-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Nasyam</h4>
                        <p class="card-text">Nasyam is a Panchakarma therapy to treat headache or ENT related disorders
                          such as sinusitis, migraine, ear, nose or throat.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Strengthens the nasal passage</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Treats nasal infections</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Remedy for congestion</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Treats allergies and sinusitis</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relieves headaches and migraine</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Nasyam',cat:'THERAPY'}" class="btn btn-primary">Book
                          Appointment</a>
                      </div>
                    </div>



                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/sweda-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Pinda Sweda</h4>
                        <p class="card-text">Pinda Sweda is a type of Ayurvedic massage which is done with warm
                          medicated herbal oils and herb bags with combination of herbs.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Promote blood circulation</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improve lymphatic drainage</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Soothes nerves and relaxes muscles</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improve skin texture</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reduces pain, swelling and stiffness</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Pinda Sweda',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                </div>

                <br>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/janu-vasti-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Janu Vasti</h4>
                        <p class="card-text">Janu Vasti is a specialized ayurvedic treatment to relieve the knee pain
                          caused due to arthritis by strengthening the knee muscles and joints.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reduces knee pain and inflammation</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relieves stiffness in the knee joint</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Stops the degeneration of the knee joints</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Lubricates and strengthens the knee joints</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Nourishes the muscles, bone and nerves of the knee area</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Janu Vasti',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/Greeva-Vasti-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Greeva Vasti</h4>
                        <p class="card-text">Greeva Vasti is essentially the holding of herbal oils on the spine,
                          starting from the neck.This helps to relieve stress and pain in the affected areas.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relief from pain and stiffness in the neck, shoulders, and upper limbs</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Relief from pain and inflammation</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improvement of neck mobility</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Increased blood supply to the neck, shoulders, and arms</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reduced frequency of headaches and dizziness</p>
                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Greeva Vasti',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>



                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/udvartanam-therapy.png" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Udvartana</h4>
                        <p class="card-text">Udvartana is a massage therapy treatment based on powders composed of
                          medicinal herbs which stimulates the metabolic process</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Liquefies the fat in the body and helps eliminate it.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Perform a lymphatic drainage of the whole body.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Activates circulation.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Helps eliminate all kinds of toxins.</p>

                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Udvartana',cat:'THERAPY'}" class="btn btn-primary">Book
                          Appointment</a>
                      </div>
                    </div>
                  </div>
                </div><br>

                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/skin-care-ayurway.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">THERAPY</h5>
                        <h4>Mukha lepam</h4>
                        <p class="card-text">Mukha lepam ayurvedic therapy is the best therapy for most of the face
                          related issues.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Detoxes, energizes and revives skin</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Naturally restores pH balance</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Promotes facial glow</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Anti-Ageing</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improves skin tone</p>

                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Mukha lepam',cat:'THERAPY'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>

                </div>





              </div>


            </div>
            <div class="tab-pane" id="tab_default_4">
              <div class="container">
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/abhyanga-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">CARE SERVICE</h5>
                        <h4>Specialities</h4>
                        <p class="card-text">We provide treatment for Neurology, Orthopedics and Ophthalmology. For
                          further assistance and information please contact us.</p>

                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Specialities',cat:'CARE SERVICE'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/ent.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">CARE SERVICE</h5>
                        <h4>Additional Services</h4>
                        <p class="card-text">We provide treatment for ENT, Hepatology and Pulmonology. For further
                          assistance and information please contact us.</p>

                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Additional Services',cat:'CARE SERVICE'}"
                          class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/kati-basti-therapy.jpg" alt="Card image cap">
                      <div class="card-body">
                        <h5 class="card-title">CARE SERVICE</h5>
                        <h4>Others</h4>
                        <p class="card-text">We provide treatment for De-Addiction and rehabilitation and mental health
                          and illness. For further assistance and information please contact us.</p>

                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Others',cat:'CARE SERVICE'}" class="btn btn-primary">Book
                          Now</a>
                      </div>
                    </div>
                  </div>
                </div><br>
                <div class="row">
                  <div class="col-lg-4 col-md-4 col-sm-12">
                    <div class="card">
                      <img class="card-img-top" src="assets/oncology-consultancy.jpg" alt="Card image cap">
                      <div class="card-body card1">
                        <h5 class="card-title">CARE SERVICE</h5>
                        <h4>{{brandData?.brandName}} Cancer Supportive Care Program (ACSC)</h4>
                        <p class="card-text">{{brandData?.brandName}} has designed an integrated approach to manage cancer utilizing
                          wisdom gained from Ayurveda, Western Herbology, Aromatherapy, Nutrition, Supplements and
                          Spiritual healing, combined with conventional cancer treatment for the individual’s
                          well-being.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Reducing side effects of conventional cancer treatments</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Prevention of Cancer relapse</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improving Quality of life.</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improving Life expectancy</p>
                        <span class="glyphicon glyphicon-triangle-right"></span>
                        <p>Improving Nutritional status with personalized diet plans</p>

                        <a [routerLink]="['/book-service']" [queryParams]="{id:getId,subCat: 'Ayurway Cancer Supportive Care Program',cat:'CARE SERVICE'}" class="btn btn-primary">Book Appointment</a>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  <div class="container gallery">

      <h1>Gallery</h1>

  <!--  <a href="https://github.com/rtpHarry/Bootstrap3-ShowManySlideOneCarousel">this code sample</a> -->
  <div class="row">
     <div class="col-md-12">
        <div class="carousel carousel-showmanymoveone slide rt-container" id="carousel-tilenav" data-interval="false">
           <div class="carousel-inner row-padding">
              <div class="item active ">
                 <div class="col-xs-12 col-sm-6 col-md-2">
                    <img style="width:100%;cursor:pointer" 
                      onclick="onClick(this)" src="../../assets/resource/gallery/g1.jpg" class="img-responsive hover-opacity">
                 </div>
              </div>
              <div class="item">
                 <div class="col-xs-12 col-sm-6 col-md-2">
                    <img style="width:100%;cursor:pointer" 
                      onclick="onClick(this)" src="../../assets/resource/gallery/g2.jpg" class="img-responsive hover-opacity">
                 </div>
              </div>
              <div class="item">
                 <div class="col-xs-12 col-sm-6 col-md-2 ">
                    <img style="width:100%;cursor:pointer" 
                      onclick="onClick(this)" src="../../assets/resource/gallery/g3.jpg" class="img-responsive hover-opacity">
                 </div>
              </div>
              <div class="item">
                 <div class="col-xs-12 col-sm-6 col-md-2">
                    <img  style="width:100%;cursor:pointer" 
                    onclick="onClick(this)" src="../../assets/resource/gallery/g4.jpg" class="img-responsive hover-opacity">
                 </div>
              </div>
              <div class="item">
                 <div class="col-xs-12 col-sm-6 col-md-2">
                    <img style="width:100%;cursor:pointer" 
                    onclick="onClick(this)" src="../../assets/resource/gallery/g5.jpg" class="img-responsive hover-opacity">
                 </div>
              </div>
              <div class="item">
                 <div class="col-xs-12 col-sm-6 col-md-2">
                    <img style="width:100%;cursor:pointer" 
                    onclick="onClick(this)" src="../../assets/resource/gallery/g6.jpg" class="img-responsive hover-opacity">
                 </div>
              </div>
              <div class="item">
                <div class="col-xs-12 col-sm-6 col-md-2">
                   <img style="width:100%;cursor:pointer" 
                   onclick="onClick(this)" src="../../assets/resource/gallery/g7.jpg" class="img-responsive hover-opacity">
                </div>
             </div>
             <div class="item">
              <div class="col-xs-12 col-sm-6 col-md-2">
                 <img style="width:100%;cursor:pointer" 
                 onclick="onClick(this)" src="../../assets/resource/gallery/g8.jpg" class="img-responsive hover-opacity">
              </div>
           </div>
           <div class="item">
            <div class="col-xs-12 col-sm-6 col-md-2">
               <img style="width:100%;cursor:pointer" 
               onclick="onClick(this)" src="../../assets/resource/gallery/g9.jpg" class="img-responsive hover-opacity">
            </div>
         </div>
         <div class="item">
          <div class="col-xs-12 col-sm-6 col-md-2">
             <img style="width:100%;cursor:pointer" 
             onclick="onClick(this)" src="../../assets/resource/gallery/g10.jpg" class="img-responsive hover-opacity">
          </div>
       </div>

           </div>
           <a class="left carousel-control" href="#carousel-tilenav" data-slide="prev"><i class="glyphicon glyphicon-chevron-left"></i></a>
           <a class="right carousel-control" href="#carousel-tilenav" data-slide="next"><i class="glyphicon glyphicon-chevron-right"></i></a>
        </div>

        

     </div>
  </div>
  
  </div>


  <div id="modal01" class="modal" onclick="this.style.display='none'">
    <span class="w3-button w3-hover-red w3-xlarge w3-display-topright w3-animate-zoom">&times;</span>
    <div class="w3-modal-content w3-animate-zoom">
      <img id="img01" style="width:100%">
    </div>
  </div>


  
  <ng-template #msg>
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">Message</h4>
      <button type="button" class="closeModal" data-dismiss="modal" (click)="modalClose()"><i
          class="bi bi-x-circle"></i></button>
    </div>
    <!-- Modal body -->
    <div class="modal-body">
      <p class="text-center p_font">{{modalService.config.initialState.message}}</p>
    </div>
    <!-- Modal footer -->
    <div class="modal-footer">
      <button type="button" class="btn-blue" (click)="modalClose()">OK</button>
    </div>

  </ng-template>
  <div class="container">
    
  </div>
